export default class ClearFormInputs {

    constructor() {
        this.settings = {
            $clearForm : $(".js-clear-form-inputs")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$clearForm.length) {
            const clearForm = document.querySelector('.js-clear-form-inputs');

            clearForm.addEventListener('click', () => {

                // Reset select inputs
                document.getElementById('service').value = '';
                document.getElementById('sector').value = '';
                document.getElementById('location').value = '';

                // Reset search input
                document.getElementById('search-input').value = '';

                // Submit the form
                document.getElementById('our-people').submit();

            }); 
        }
    }
};

new ClearFormInputs();
